/* Vitamin Life · Sol — tot comportamentul temei, fără biblioteci. */
(() => {
  const V = window.VD || {};
  const R = V.routes || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = document.documentElement;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Texte traduse (din vd-config, cu româna ca rezervă) ---------- */
  const I = Object.assign({
    add_error: 'Nu am putut adăuga produsul. Încearcă din nou.',
    update_error: 'Nu am putut actualiza coșul.',
    cart_aria: 'Coșul, {n} produse',
    add: 'Adaugă',
    no_thanks: 'Nu, mulțumesc',
    down_before_html: 'Înainte să renunți: <span>{title}</span> te costă doar {price}.',
    down_keep_html: 'Păstrezi măcar <span>o cutie</span> de {title}?',
    one_piece: '1 bucată',
    keep_one: 'Păstrez una',
    upgraded: 'Ai trecut la pachetul mai avantajos.',
    disc_later: 'Codul {code} se aplică la finalizarea comenzii.',
    disc_ok: 'Codul {code} a fost aplicat.',
    disc_bad: 'Codul {code} nu există sau nu se aplică acestui coș.',
    disc_error: 'Nu am putut verifica codul. Încearcă din nou.',
    copied: 'Copiat',
    copied_toast: 'Codul {code} e copiat. Îl lipești la checkout.',
    nl_done: 'Gata! Codul e mai jos.',
    search_empty: 'Nu am găsit „{q}”. Încearcă „dibase” sau „oki”.',
    days: 'duminică,luni,marți,miercuri,joi,vineri,sâmbătă',
    months: 'ian.,feb.,mar.,apr.,mai,iun.,iul.,aug.,sept.,oct.,nov.,dec.',
    day_fmt: '{wd}, {d} {mon}',
    tomorrow: 'mâine',
    eta_time_hm: '{h} h {m} min',
    eta_time_m: '{m} min',
    eta_today_html: 'Comandă în <b>{time}</b> și coletul pleacă <b>azi</b>.',
    eta_later_html: 'Comandă acum și coletul pleacă <b>{day}</b>.',
    eta_arrive_html: 'Ajunge <b>{when}</b>',
    cd_label_in: 'Următorul transport pleacă în',
    cd_label: 'Următorul transport pleacă',
    cd_today: 'Comanzi acum și coletul pleacă azi. Ajunge {when}.',
    cd_later: 'Comanzi acum și coletul pleacă {day} dimineață. Ajunge {when}.',
    plan_once: 'O singură dată',
    plan_sub: 'Abonament',
    save: 'Economisești {amount}',
    free_ship: 'Livrare gratuită',
    subscribe: 'Abonează-te',
    add_to_cart: 'Adaugă în coș',
    sold_out: 'Stoc epuizat',
    fbt_free: 'cu livrare gratuită',
    fbt_free_from: 'livrare gratuită de la {amount}',
    fbt_add_n: 'Adaugă {n} produse în coș',
    bf_starts: 'Începe în',
    bf_ends: 'Se termină în',
    bf_live: 'E Black Friday, doar azi',
    bf_d: 'z'
  }, V.i18n || {});
  /* Înlocuiește {cheie} din text cu valorile date */
  const tpl = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (o && k in o ? o[k] : m));

  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* stocare indisponibilă */ } }
  };

  /* ---------- Preț ---------- */
  function money(cents) {
    const fmt = V.money || '{{amount_with_comma_separator}} lei';
    const n = (cents || 0) / 100;
    const fix = (v, d, ts, ds) => {
      const [i, f] = v.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fix(n, 2, ',', '.');
        case 'amount_no_decimals': return fix(n, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(n, 2, "'", '.');
        default: return fix(n, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-on'), 3200);
  }

  /* ---------- Suprapuneri (meniu, căutare, coș, pop-up) ---------- */
  let lastFocus = null;
  function openLayer(el, cls) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (cls) root.classList.add(cls);
  }
  function closeLayer(el, cls) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (cls) root.classList.remove(cls);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Coș ---------- */
  function drawer() { return $('#CartDrawer'); }
  function openCart() {
    const d = drawer();
    if (!d) { location.href = R.cart; return; }
    lastFocus = document.activeElement;
    root.classList.add('cart-open');
    d.setAttribute('aria-hidden', 'false');
    const panel = $('.drawer__panel', d);
    if (panel) { panel.setAttribute('tabindex', '-1'); setTimeout(() => panel.focus({ preventScroll: true }), 60); }
    closePopup(true);
  }
  function closeCart() {
    root.classList.remove('cart-open');
    const d = drawer();
    if (d) d.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      if (n) el.classList.add('is-bump');
    });
    $$('[data-cart-open]').forEach((a) => a.setAttribute('aria-label', tpl(I.cart_aria, { n })));
  }
  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('.drawer');
    const cur = drawer();
    if (!fresh || !cur) return;
    const open = root.classList.contains('cart-open');
    const scroll = $('.drawer__body', cur) ? $('.drawer__body', cur).scrollTop : 0;
    const discOpen = $('.disc', cur) && $('.disc', cur).open;
    cur.replaceWith(fresh);
    fresh.setAttribute('aria-hidden', open ? 'false' : 'true');
    const body = $('.drawer__body', fresh);
    if (body) body.scrollTop = scroll;
    if (discOpen && $('.disc', fresh)) $('.disc', fresh).open = true;
    const n = $('.drawer__n', fresh);
    setCount(n ? parseInt(n.textContent, 10) || 0 : 0);
    if (fresh.dataset.insOrphan) changeLine(fresh.dataset.insOrphan, 0).catch(() => {});
  }
  async function cartPost(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: 'cart-drawer', sections_url: location.pathname }))
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw data;
    return data;
  }
  async function addItems(items, opts = {}) {
    try {
      const data = await cartPost(`${R.add}.js`, { items });
      renderDrawer(data.sections);
      if (opts.open !== false) openCart();
      return data;
    } catch (err) {
      toast((err && (err.description || err.message)) || I.add_error);
      throw err;
    }
  }
  async function changeLine(key, quantity) {
    const data = await cartPost(`${R.change}.js`, { id: key, quantity });
    renderDrawer(data.sections);
    return data;
  }
  async function refreshDrawer() {
    try {
      const res = await fetch(`${R.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      renderDrawer(await res.json());
    } catch (e) { /* rețea */ }
  }

  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function showDownsell(raw, qty) {
    const slot = $('[data-downsell-slot]', drawer());
    if (!slot) return;
    const info = {};
    Object.keys(raw).forEach((k) => { info[k] = esc(raw[k]); });
    let html = '';
    if (info.downId) {
      html = `<div class="down" role="status">
        <p class="down__t">${tpl(I.down_before_html, { title: info.downTitle, price: info.downPrice })}</p>
        <div class="down__row">${info.downImg ? `<img src="${info.downImg}" alt="" width="56" height="56">` : ''}
          <div><b>${info.downTitle}</b><span>${info.downPrice}</span></div>
          <button type="button" class="btn btn--sun btn--sm" data-add="${info.downId}">${esc(I.add)}</button></div>
        <button type="button" class="down__x" data-down-close>${esc(I.no_thanks)}</button></div>`;
    } else if (qty >= 2 && info.variant) {
      html = `<div class="down" role="status">
        <p class="down__t">${tpl(I.down_keep_html, { title: info.title })}</p>
        <div class="down__row"><div><b>${info.title}</b><span>${esc(I.one_piece)}</span></div>
          <button type="button" class="btn btn--sun btn--sm" data-add="${info.variant}">${esc(I.keep_one)}</button></div>
        <button type="button" class="down__x" data-down-close>${esc(I.no_thanks)}</button></div>`;
    }
    slot.innerHTML = html;
    const body = slot.closest('.drawer__body');
    if (html && body) body.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async function applyDiscount(code, remove) {
    const msg = () => $('[data-discount-msg]', drawer());
    try {
      const cart = await fetch(`${R.cart}.js`).then((r) => r.json());
      let codes = (cart.discount_codes || []).map((d) => d.code);
      if (remove) codes = codes.filter((c) => c.toLowerCase() !== code.toLowerCase());
      else if (!codes.some((c) => c.toLowerCase() === code.toLowerCase())) codes.push(code);
      const data = await cartPost(`${R.update}.js`, { discount: codes.join(',') });
      if (!('discount_codes' in data)) {
        await fetch(`/discount/${encodeURIComponent(code)}`);
        renderDrawer(data.sections);
        const m = msg();
        if (m) { m.textContent = tpl(I.disc_later, { code }); m.className = 'disc__msg is-ok'; }
        return;
      }
      renderDrawer(data.sections);
      if (remove) return;
      const hit = (data.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (!hit || !hit.applicable) {
        const keep = (data.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
        const clean = await cartPost(`${R.update}.js`, { discount: keep.join(',') });
        renderDrawer(clean.sections);
      }
      const m = msg();
      const d = $('.disc', drawer());
      if (d) d.open = true;
      if (!m) return;
      if (hit && hit.applicable) { m.textContent = tpl(I.disc_ok, { code: hit.code }); m.className = 'disc__msg is-ok'; }
      else { m.textContent = tpl(I.disc_bad, { code }); m.className = 'disc__msg is-err'; }
    } catch (e) {
      const m = msg();
      if (m) { m.textContent = I.disc_error; m.className = 'disc__msg is-err'; }
    }
  }

  /* ---------- Delegare evenimente ---------- */
  document.addEventListener('click', async (e) => {
    const t = e.target;
    const q = (s) => t.closest(s);

    if (q('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (q('[data-cart-close]')) { closeCart(); return; }
    if (q('[data-mnav-open]')) { openLayer($('[data-mnav]'), 'mnav-open'); return; }
    if (q('[data-mnav-close]')) { closeLayer($('[data-mnav]'), 'mnav-open'); return; }
    if (q('[data-search-open]')) { openLayer($('[data-search]'), 'search-open'); setTimeout(() => $('[data-search-input]') && $('[data-search-input]').focus(), 80); return; }
    if (q('[data-search-close]')) { closeLayer($('[data-search]'), 'search-open'); return; }
    if (q('[data-popup-close]')) { closePopup(); return; }
    if (q('[data-down-close]')) { const s = $('[data-downsell-slot]', drawer()); if (s) s.innerHTML = ''; return; }

    const copy = q('[data-copy]');
    if (copy) {
      const code = copy.dataset.copy;
      try { await navigator.clipboard.writeText(code); } catch (err) { /* fără acces la clipboard */ }
      copy.classList.add('is-copied');
      const s = $('small', copy);
      if (s) s.textContent = I.copied;
      toast(tpl(I.copied_toast, { code }));
      return;
    }

    const add = q('[data-add]');
    if (add) {
      add.classList.add('is-loading');
      try { await addItems([{ id: Number(add.dataset.add), quantity: Number(add.dataset.qty || 1) }]); } catch (err) { /* afișat în toast */ }
      add.classList.remove('is-loading');
      return;
    }

    const line = q('[data-line]');
    if (line) {
      const key = line.dataset.key;
      const qty = Number(line.dataset.qty);
      const step = q('[data-qty-step]');
      const rm = q('[data-remove]');
      const up = q('[data-upgrade]');
      if (step || rm || up) {
        line.classList.add('is-busy');
        try {
          if (step) {
            const nq = Math.max(0, qty + Number(step.dataset.qtyStep));
            const info = Object.assign({}, line.dataset);
            await changeLine(key, nq);
            if (nq === 0) showDownsell(info, qty);
          } else if (rm) {
            const info = Object.assign({}, line.dataset);
            await changeLine(key, 0);
            showDownsell(info, qty);
          } else if (up) {
            await cartPost(`${R.change}.js`, { id: key, quantity: Number(up.dataset.newq) });
            await addItems([{ id: Number(up.dataset.to), quantity: 1 }]);
            toast(I.upgraded);
          }
        } catch (err) {
          line.classList.remove('is-busy');
          toast((err && err.description) || I.update_error);
        }
        return;
      }
    }

    const rmCode = q('[data-discount-remove]');
    if (rmCode) { applyDiscount(rmCode.dataset.discountRemove, true); return; }

    const th = q('[data-gal-th]');
    if (th) {
      const g = th.closest('[data-gallery]');
      $$('[data-gal-th]', g).forEach((b) => b.classList.toggle('is-on', b === th));
      swapImage($('[data-gal-main]', g), th.dataset.galTh);
      return;
    }

    const tab = q('[data-dose-tab]');
    if (tab) { selectDose(tab.closest('[data-dose]'), Number(tab.dataset.doseTab)); return; }

    const rec = q('[data-recover]');
    if (rec) { e.preventDefault(); const f = $('#recover'); if (f) f.scrollIntoView({ behavior: 'smooth' }); }
  });

  document.addEventListener('submit', async (e) => {
    const f = e.target;
    if (f.matches('[data-quick-add]')) {
      e.preventDefault();
      const btn = $('button[type="submit"]', f);
      if (btn) btn.classList.add('is-loading');
      try {
        await addItems([{ id: Number(f.querySelector('[name="id"]').value), quantity: Number((f.querySelector('[name="quantity"]') || {}).value || 1) }]);
      } catch (err) { /* afișat în toast */ }
      if (btn) btn.classList.remove('is-loading');
      return;
    }
    if (f.matches('[data-discount-form]')) {
      e.preventDefault();
      const code = (f.code.value || '').trim();
      if (!code) return;
      const b = $('button', f);
      if (b) b.classList.add('is-loading');
      await applyDiscount(code);
      return;
    }
    if (f.matches('[data-popup-form], [data-nl-form]')) {
      e.preventDefault();
      const btn = $('button[type="submit"]', f);
      if (btn) btn.classList.add('is-loading');
      try {
        const res = await fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } });
        if (res.redirected && /challenge/.test(res.url)) { f.submit(); return; }
        const box = f.parentElement.querySelector('[data-code-box][hidden]') || f.querySelector('[data-code-box][hidden]');
        const fields = f.querySelector('.field');
        if (fields) fields.hidden = true;
        if (box) box.hidden = false;
        store.set('vd_sub', '1');
        toast(I.nl_done);
      } catch (err) {
        f.submit();
      }
      if (btn) btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('cart-open')) closeCart();
    closeLayer($('[data-mnav].is-open'), 'mnav-open');
    closeLayer($('[data-search].is-open'), 'search-open');
    closePopup();
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshDrawer(); });
  { const d0 = drawer(); if (d0 && d0.dataset.insOrphan) changeLine(d0.dataset.insOrphan, 0).catch(() => {}); }

  /* ---------- Antet ---------- */
  const hdr = $('[data-header]');
  if (hdr) {
    const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Bara de anunțuri ---------- */
  const ann = $('[data-ann]');
  if (ann) {
    const items = $$('.ann__item', ann);
    if (items.length > 1 && !reduced) {
      let i = 0;
      setInterval(() => {
        const cur = items[i];
        i = (i + 1) % items.length;
        const nxt = items[i];
        cur.classList.remove('is-on');
        cur.classList.add('is-out');
        nxt.classList.remove('is-out');
        nxt.classList.add('is-on');
        setTimeout(() => cur.classList.remove('is-out'), 600);
      }, 4200);
    }
  }

  /* ---------- Căutare instant ---------- */
  const sInput = $('[data-search-input]');
  const sOut = $('[data-search-results]');
  if (sInput && sOut && R.search) {
    const hint = sOut.innerHTML;
    let t;
    sInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = sInput.value.trim();
      if (q.length < 2) { sOut.innerHTML = hint; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${R.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`);
          const data = await res.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { sOut.innerHTML = `<p class="srch__hint">${esc(tpl(I.search_empty, { q }))}</p>`; return; }
          sOut.innerHTML = `<div class="srch__list">${items.map((p) => `
            <a class="srch__item" href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="" width="56" height="56" loading="lazy">` : ''}
              <div><b>${p.title}</b><span>${money(Math.round(parseFloat(p.price) * 100))}</span></div>
            </a>`).join('')}</div>`;
        } catch (err) { /* rețea */ }
      }, 180);
    });
  }

  /* ---------- Apariție la scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  $$('[data-reveal], .cmpc, .bt--ship').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* ---------- Hero: carusel 3D ---------- */
  $$('[data-flow]').forEach((stage) => {
    const cards = $$('[data-flow-card]', stage);
    const dots = $$('[data-flow-dot]', stage);
    const n = cards.length;
    if (n < 2) return;
    const T = 4200;
    stage.style.setProperty('--flow-t', `${T}ms`);
    let active = 0;
    let timer;
    function set(i) {
      active = (i + n) % n;
      cards.forEach((c, k) => {
        const rel = (k - active + n) % n;
        let pos = 'far';
        if (rel === 0) pos = '0';
        else if (rel === 1) pos = '1';
        else if (rel === n - 1) pos = '-1';
        c.dataset.pos = pos;
        c.setAttribute('tabindex', pos === '0' ? '0' : '-1');
      });
      dots.forEach((d, k) => {
        d.classList.remove('is-on');
        void d.offsetWidth;
        if (k === active) d.classList.add('is-on');
        d.setAttribute('aria-selected', k === active ? 'true' : 'false');
      });
    }
    const auto = stage.hasAttribute('data-autoplay');
    const start = () => { if (reduced || !auto) return; clearInterval(timer); timer = setInterval(() => set(active + 1), T); };
    const stop = () => clearInterval(timer);
    stage.addEventListener('click', (e) => {
      const c = e.target.closest('[data-flow-card]');
      if (c && c.dataset.pos !== '0') { e.preventDefault(); set(Number(c.dataset.flowCard)); start(); return; }
      const d = e.target.closest('[data-flow-dot]');
      if (d) { set(Number(d.dataset.flowDot)); start(); }
    });
    if (finePointer) {
      stage.addEventListener('mouseenter', () => { stop(); stage.classList.add('is-paused'); });
      stage.addEventListener('mouseleave', () => { stage.classList.remove('is-paused'); start(); });
    }
    let x0 = null;
    stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { set(active + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    set(0);
    start();
  });

  /* ---------- Livrare estimată (ora României) ---------- */
  /* Numele zilelor și lunilor în limba activă (din I.days / I.months, separate prin virgulă) */
  const DAYS = String(I.days).split(',').map((x) => x.trim());
  const MONTHS = String(I.months).split(',').map((x) => x.trim());
  const isWork = (d) => d.getDay() !== 0 && d.getDay() !== 6;
  const roNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Bucharest' }));
  const addWork = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (isWork(r)) n -= 1; } return r; };
  const fmtDay = (d) => tpl(I.day_fmt, { wd: DAYS[d.getDay()], d: d.getDate(), mon: MONTHS[d.getMonth()] });
  function etaText() {
    const now = roNow();
    const cut = Number(V.cutoff || 15);
    let ship;
    let lead;
    if (isWork(now) && now.getHours() < cut) {
      ship = new Date(now);
      const mins = cut * 60 - (now.getHours() * 60 + now.getMinutes());
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      lead = tpl(I.eta_today_html, { time: h ? tpl(I.eta_time_hm, { h, m }) : tpl(I.eta_time_m, { m }) });
    } else {
      ship = new Date(now);
      ship.setDate(ship.getDate() + 1);
      while (!isWork(ship)) ship.setDate(ship.getDate() + 1);
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const label = ship.toDateString() === tomorrow.toDateString() ? I.tomorrow : DAYS[ship.getDay()];
      lead = tpl(I.eta_later_html, { day: label });
    }
    const a = addWork(ship, Number(V.shipMin || 1));
    const b = addWork(ship, Number(V.shipMax || 2));
    const when = `${fmtDay(a)}${b > a ? ` – ${fmtDay(b)}` : ''}`;
    return `${lead} ${tpl(I.eta_arrive_html, { when })}${when.endsWith('.') ? '' : '.'}`;
  }
  const etas = $$('[data-eta-text]');
  if (etas.length) {
    const tick = () => { const t = etaText(); etas.forEach((el) => { el.innerHTML = t; }); };
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Bento: cronometru real până la ora-limită și contor ---------- */
  $$('[data-countdown]').forEach((box) => {
    const timeEl = $('[data-countdown-time]', box);
    const labelEl = $('[data-countdown-label]', box);
    const subEl = $('[data-countdown-sub]', box);
    const ring = $('[data-countdown-ring]', box);
    const C = 326.7;
    const pad = (x) => String(x).padStart(2, '0');
    function tick() {
      const now = roNow();
      const cut = Number(V.cutoff || 15);
      if (isWork(now) && now.getHours() < cut) {
        const end = new Date(now); end.setHours(cut, 0, 0, 0);
        const s = Math.max(0, Math.floor((end - now) / 1000));
        timeEl.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
        labelEl.textContent = I.cd_label_in;
        subEl.textContent = tpl(I.cd_today, { when: etaDays(now) }).replace(/\.\.$/, '.');
        if (ring) ring.style.strokeDashoffset = String(C * (1 - s / (cut * 3600)));
      } else {
        const ship = new Date(now);
        ship.setDate(ship.getDate() + 1);
        while (!isWork(ship)) ship.setDate(ship.getDate() + 1);
        const tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
        const label = ship.toDateString() === tomorrow.toDateString() ? I.tomorrow : DAYS[ship.getDay()];
        labelEl.textContent = I.cd_label;
        timeEl.textContent = label;
        subEl.textContent = tpl(I.cd_later, { day: label, when: etaDays(ship) }).replace(/\.\.$/, '.');
        if (ring) ring.style.strokeDashoffset = '0';
      }
    }
    tick();
    setInterval(tick, 1000);
  });
  function etaDays(ship) {
    const a = addWork(ship, Number(V.shipMin || 1));
    const b = addWork(ship, Number(V.shipMax || 2));
    return `${fmtDay(a)}${b > a ? ` – ${fmtDay(b)}` : ''}`;
  }
  $$('[data-count-to]').forEach((el) => {
    const to = Number(el.dataset.countTo);
    const suffix = el.textContent.trim().endsWith('+') ? '+' : '';
    if (!to || reduced || !io) return;
    const run = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      run.disconnect();
      const t0 = performance.now();
      const dur = 1600;
      const step = (t) => {
        const k = Math.min(1, (t - t0) / dur);
        const v = Math.round(to * (1 - Math.pow(1 - k, 3)));
        el.textContent = v.toLocaleString(V.lang || 'ro') + suffix;
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }, { threshold: 0.4 });
    run.observe(el);
  });

  /* ---------- DIBASE: alege doza ---------- */
  function selectDose(sec, i) {
    if (!sec) return;
    const tabs = $$('[data-dose-tab]', sec);
    tabs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    $$('[data-dose-panel]', sec).forEach((p, k) => { p.hidden = k !== i; p.classList.toggle('is-on', k === i); });
    const fill = $('[data-dose-fill]', sec);
    if (fill && tabs.length > 1) fill.style.width = `${(i / (tabs.length - 1)) * 100}%`;
    // Pe telefon cadranul derulează: aducem doza aleasă la mijloc.
    const dial = tabs[i] && tabs[i].parentElement;
    if (dial && dial.scrollWidth > dial.clientWidth) {
      dial.scrollTo({ left: tabs[i].offsetLeft - (dial.clientWidth - tabs[i].offsetWidth) / 2, behavior: 'smooth' });
    }
  }
  $$('[data-dose]').forEach((sec) => {
    const tabs = $$('[data-dose-tab]', sec);
    const on = tabs.findIndex((t) => t.classList.contains('is-on'));
    selectDose(sec, on < 0 ? 0 : on);
    sec.addEventListener('keydown', (e) => {
      if (!e.target.matches('[data-dose-tab]')) return;
      const i = tabs.indexOf(e.target);
      let n = -1;
      if (e.key === 'ArrowRight') n = Math.min(tabs.length - 1, i + 1);
      if (e.key === 'ArrowLeft') n = Math.max(0, i - 1);
      if (n >= 0) { e.preventDefault(); selectDose(sec, n); tabs[n].focus(); }
    });
  });

  /* ---------- Transport asigurat (bifă în coș) ---------- */
  document.addEventListener('change', async (e) => {
    const box = e.target.closest('[data-ins]');
    if (!box) return;
    const label = box.closest('.ins');
    if (label) label.classList.add('is-busy');
    try {
      if (box.checked) await addItems([{ id: Number(box.dataset.insVariant), quantity: 1 }]);
      else if (box.dataset.insKey) await changeLine(box.dataset.insKey, 0);
    } catch (err) {
      box.checked = !box.checked;
      if (label) label.classList.remove('is-busy');
    }
  });

  /* ---------- Scena produsului: adâncime la mișcarea mouse-ului ---------- */
  if (finePointer && !reduced) {
    $$('[data-stage]').forEach((st) => {
      const disc = $('[data-stage-disc]', st);
      if (!disc) return;
      st.addEventListener('pointermove', (e) => {
        const r = st.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        st.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
        st.style.setProperty('--ry', `${(x * 12).toFixed(2)}deg`);
        st.style.setProperty('--mx', `${(x * 100 + 50).toFixed(1)}%`);
        st.style.setProperty('--my', `${(y * 100 + 50).toFixed(1)}%`);
      });
      st.addEventListener('pointerleave', () => {
        st.style.setProperty('--rx', '0deg');
        st.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Galerie ---------- */
  function swapImage(img, src) {
    if (!img || !src || img.currentSrc === src) return;
    img.classList.add('is-swap');
    const pre = new Image();
    pre.onload = () => { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; img.classList.remove('is-swap'); };
    pre.onerror = () => img.classList.remove('is-swap');
    pre.src = src;
  }

  /* ---------- Pagina produsului ---------- */
  $$('[data-pdp]').forEach((sec) => {
    const jsonEl = $('[data-pdp-json]', sec);
    const form = $('[data-pdp-form]', sec);
    if (!jsonEl || !form) return;
    let J;
    try { J = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const els = {
      id: $('[data-id]', form), qty: $('[data-qty]', form), plan: $('[data-plan]', form),
      price: $('[data-price]', sec), compare: $('[data-compare]', sec), save: $('[data-save]', sec), unit: $('[data-unit]', sec),
      atc: $('[data-atc]', form), atcLabel: $('[data-atc-label]', form), atcPrice: $('[data-atc-price]', form),
      buyNow: $('[data-buy-now]', form), ptype: $('[data-ptype]', form), ptSel: $('[data-pt-select]', form), ptNote: $('[data-pt-note]', form),
      main: $('[data-gal-main]', sec), stickyPrice: sec.matches('.pdp') ? $('[data-sticky-price]') : null, stickyBtn: sec.matches('.pdp') ? $('[data-sticky-atc]') : null
    };
    const optEls = $$('[data-opt]', form);
    let sel = Number(J.pick) || 0;
    if (J.options[sel] && !J.options[sel].available) sel = Math.max(0, J.options.findIndex((o) => o.available));
    let mode = 'once';
    let planIdx = 0;

    function buildPlans(o, plans) {
      if (!els.ptSel) return;
      const val = mode === 'sub' ? String(planIdx) : 'once';
      els.ptSel.innerHTML = [`<option value="once">${esc(I.plan_once)} · ${money(o.price)}</option>`]
        .concat(plans.map((p, i) => `<option value="${i}">${esc(I.plan_sub)}: ${p.name}${p.pct ? ` · −${p.pct}%` : ''} · ${money(p.price)}</option>`))
        .join('');
      els.ptSel.value = val;
    }

    function render() {
      const o = J.options[sel];
      if (!o) return;
      optEls.forEach((el, i) => {
        el.classList.toggle('is-on', i === sel);
        const r = $('input', el);
        if (r) r.checked = i === sel;
      });
      els.id.value = o.id;
      els.qty.value = o.q;
      const plans = o.plans || [];
      if (els.ptype) els.ptype.hidden = !plans.length;
      if (!plans.length) mode = 'once';
      let price = o.price;
      let compare = o.compare;
      if (plans.length) {
        planIdx = Math.min(planIdx, plans.length - 1);
        buildPlans(o, plans);
        const p = plans[planIdx] || plans[0];
        if (els.ptNote) els.ptNote.hidden = mode !== 'sub';
        if (els.ptype) els.ptype.classList.toggle('is-sub', mode === 'sub');
        if (mode === 'sub') {
          price = p.price;
          compare = Math.max(o.compare, o.price);
          els.plan.disabled = false;
          els.plan.value = p.id;
        } else {
          els.plan.disabled = true;
          els.plan.value = '';
        }
      } else {
        els.plan.disabled = true;
        els.plan.value = '';
      }
      els.price.textContent = money(price);
      const hasCmp = compare > price;
      if (els.compare) { els.compare.hidden = !hasCmp; els.compare.textContent = money(compare); }
      if (els.save) { els.save.hidden = !hasCmp; els.save.textContent = tpl(I.save, { amount: money(compare - price) }); }
      if (els.unit) {
        const up = o.unitPrice ? Math.round(o.unitPrice * (price / o.price)) : 0;
        const shipMsg = J.freeShip && price >= J.freeShip ? I.free_ship : '';
        els.unit.textContent = [up ? `${money(up)} / ${J.unit}` : '', shipMsg].filter(Boolean).join(' · ');
      }
      if (els.atcPrice) els.atcPrice.textContent = money(price);
      if (els.atc) {
        els.atc.disabled = !o.available;
        if (els.atcLabel) els.atcLabel.textContent = o.available ? (mode === 'sub' ? I.subscribe : I.add_to_cart) : I.sold_out;
      }
      if (els.buyNow) els.buyNow.disabled = !o.available;
      if (els.stickyBtn) els.stickyBtn.disabled = !o.available;
      if (els.stickyPrice) els.stickyPrice.textContent = money(price);
      if (o.img && els.main) swapImage(els.main, o.img);
      renderFbt(price, o);
    }

    const fbt = $('[data-fbt]', sec);
    function renderFbt(price, o) {
      if (!fbt) return;
      const extras = $$('[data-fbt-id]', fbt).filter((c) => c.checked);
      const total = price + extras.reduce((a, c) => a + Number(c.dataset.fbtPrice), 0);
      const mp = $('[data-fbt-main-price]', fbt);
      const ml = $('[data-fbt-main-label]', fbt);
      if (mp) mp.textContent = money(price);
      if (ml && o) ml.textContent = o.title + (o.q > 1 ? ` × ${o.q}` : '');
      $('[data-fbt-total]', fbt).textContent = money(total);
      const ship = $('[data-fbt-ship]', fbt);
      if (ship) ship.textContent = J.freeShip && total >= J.freeShip ? I.fbt_free : (J.freeShip ? tpl(I.fbt_free_from, { amount: money(J.freeShip) }) : '');
      const lbl = $('[data-fbt-label]', fbt);
      if (lbl) lbl.textContent = extras.length ? tpl(I.fbt_add_n, { n: extras.length + 1 }) : I.add_to_cart;
      fbt.dataset.total = total;
    }
    if (fbt) {
      fbt.addEventListener('change', (e) => { if (e.target.matches('[data-fbt-id]')) render(); });
      const fbtBtn = $('[data-fbt-add]', fbt);
      fbtBtn.addEventListener('click', async () => {
        const items = [payload()].concat($$('[data-fbt-id]', fbt).filter((c) => c.checked).map((c) => ({ id: Number(c.dataset.fbtId), quantity: 1 })));
        fbtBtn.classList.add('is-loading');
        try { await addItems(items); } catch (err) { /* afișat în toast */ }
        fbtBtn.classList.remove('is-loading');
      });
    }

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.name && t.name.indexOf('vd-opt') === 0) { sel = Number(t.value); render(); }
      if (t.matches('[data-pt-select]')) {
        if (t.value === 'once') mode = 'once';
        else { mode = 'sub'; planIdx = Number(t.value); }
        render();
      }
      if (t.matches('[data-variant-select]')) { els.id.value = t.value; }
    });

    function payload() {
      const item = { id: Number(els.id.value), quantity: Number(els.qty.value) || 1 };
      if (!els.plan.disabled && els.plan.value) item.selling_plan = Number(els.plan.value);
      return item;
    }
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      els.atc.classList.add('is-loading');
      try { await addItems([payload()]); } catch (err) { /* afișat în toast */ }
      els.atc.classList.remove('is-loading');
    });
    if (els.buyNow) {
      els.buyNow.addEventListener('click', async () => {
        els.buyNow.classList.add('is-loading');
        try {
          await addItems([payload()], { open: false });
          location.href = '/checkout';
        } catch (err) {
          els.buyNow.classList.remove('is-loading');
        }
      });
    }

    const sticky = $('[data-sticky]');
    const btns = $('.buy__btns', form);
    if (sticky && btns && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(btns);
      if (els.stickyBtn) els.stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }

    render();
  });

  /* ---------- Sortare colecție ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    location.href = u.toString();
  }));

  /* ---------- Pop-up cu reducere ---------- */
  const pop = $('[data-popup]');
  let popShown = false;
  function closePopup(silent) {
    if (!pop || !pop.classList.contains('is-open')) return;
    closeLayer(pop, 'pop-open');
    if (!silent) store.set('vd_pop', String(Date.now()));
  }
  function maybePopup() {
    if (!pop || popShown || !(V.popup && V.popup.on)) return;
    if (root.classList.contains('cart-open') || root.classList.contains('mnav-open')) return;
    if (store.get('vd_sub')) return;
    const last = Number(store.get('vd_pop') || 0);
    if (last && Date.now() - last < 7 * 864e5) return;
    popShown = true;
    store.set('vd_pop', String(Date.now()));
    openLayer(pop, 'pop-open');
  }
  if (pop) {
    if (/customer_posted=true/.test(location.search) || /contact_posted/.test(location.hash)) {
      store.set('vd_sub', '1');
      if ($('[data-copy]', pop) && !$('[data-code-box][hidden]', pop)) openLayer(pop, 'pop-open');
    }
    setTimeout(maybePopup, (Number(V.popup && V.popup.delay) || 25) * 1000);
    if (finePointer) document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) maybePopup(); });
  }

  /* ---------- Black Friday: numărătoare, mod înainte / în ziua respectivă ---------- */
  if (V.bf && V.bf.on && V.bf.date) {
    const [y, mo, da] = String(V.bf.date).split('-').map(Number);
    const pad2 = (x) => String(x).padStart(2, '0');
    const offsetFor = (dt) => {
      const loc = new Date(dt.toLocaleString('en-US', { timeZone: 'Europe/Bucharest' }));
      const utc = new Date(dt.toLocaleString('en-US', { timeZone: 'UTC' }));
      return loc - utc;
    };
    const probe = new Date(Date.UTC(y, mo - 1, da, 12));
    const off = offsetFor(probe);
    const start = new Date(Date.UTC(y, mo - 1, da, 0, 0, 0) - off);
    const end = new Date(Date.UTC(y, mo - 1, da + 1, 0, 0, 0) - off);
    const bfEls = {
      teaser: $$('[data-bf-teaser-only]'), live: $$('[data-bf-live-only]'), shorts: $$('[data-bf-short]'),
      d: $$('[data-bf-d]'), h: $$('[data-bf-h]'), m: $$('[data-bf-m]'), s: $$('[data-bf-s]'),
      label: $$('[data-bf-count-label]'), when: $$('[data-bf-when]')
    };
    let lastMode = '';
    const bfTick = () => {
      const now = new Date();
      const mode = now < start ? 'teaser' : (now < end ? 'live' : 'over');
      if (mode === 'over') {
        $$('[data-bf-bar], [data-bf-section], [data-bf-pill], [data-bf-strip]').forEach((el) => { el.hidden = true; });
        return;
      }
      if (mode !== lastMode) {
        lastMode = mode;
        bfEls.teaser.forEach((el) => { el.hidden = mode !== 'teaser'; });
        bfEls.live.forEach((el) => { el.hidden = mode !== 'live'; });
        bfEls.label.forEach((el) => { el.textContent = mode === 'live' ? I.bf_ends : I.bf_starts; });
        if (mode === 'live') bfEls.when.forEach((el) => { el.textContent = I.bf_live; });
        document.documentElement.classList.toggle('bf-live', mode === 'live');
        $$('[data-bf-strip]').forEach((el) => { el.hidden = false; });
      }
      let ms = Math.max(0, (mode === 'live' ? end : start) - now);
      const D = Math.floor(ms / 864e5); ms -= D * 864e5;
      const H = Math.floor(ms / 36e5); ms -= H * 36e5;
      const M = Math.floor(ms / 6e4); ms -= M * 6e4;
      const S = Math.floor(ms / 1e3);
      bfEls.d.forEach((el) => { el.textContent = pad2(D); });
      bfEls.h.forEach((el) => { el.textContent = pad2(H); });
      bfEls.m.forEach((el) => { el.textContent = pad2(M); });
      bfEls.s.forEach((el) => { el.textContent = pad2(S); });
      const short = D > 0 ? `${D}${I.bf_d} ${pad2(H)}:${pad2(M)}:${pad2(S)}` : `${pad2(H)}:${pad2(M)}:${pad2(S)}`;
      bfEls.shorts.forEach((el) => { el.textContent = short; });
    };
    bfTick();
    setInterval(bfTick, 1000);

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-bf-open]');
      if (!opener || lastMode !== 'teaser') return;
      const p = $('[data-popup]');
      if (!p) return;
      e.preventDefault();
      popShown = true;
      openLayer(p, 'pop-open');
    });

    const pill = $('[data-bf-pill]');
    if (pill) {
      // Pastila nu stă peste subsol (selectorul de limbă, linkuri) și nici lângă bara fixă de cumpărare.
      const foot = $('.ftr');
      const bar = $('[data-sticky]');
      const onScroll = () => requestAnimationFrame(() => {
        const nearFoot = foot && foot.getBoundingClientRect().top < window.innerHeight;
        const barOn = bar && bar.classList.contains('is-on');
        pill.hidden = window.scrollY < 700 || lastMode === 'over' || nearFoot || barOn;
      });
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      if (bar && 'MutationObserver' in window) new MutationObserver(onScroll).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---------- Pagina de produs: coloana stângă lipită fără gol ----------
     Când coloana e mai înaltă decât ecranul, se lipește cu partea de jos la marginea ecranului. */
  const pdpLeft = $('[data-pdp-left]');
  if (pdpLeft) {
    const fitLeft = () => {
      const hdr = parseFloat(getComputedStyle(root).getPropertyValue('--hdr-h')) || 86;
      const top = Math.min(hdr + 18, window.innerHeight - pdpLeft.offsetHeight - 24);
      pdpLeft.style.setProperty('--pdp-left-top', `${Math.round(top)}px`);
    };
    fitLeft();
    window.addEventListener('resize', fitLeft, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(fitLeft).observe(pdpLeft);
  }

  /* ---------- Limbă și țară: fereastra din antet, trimitere la schimbare ---------- */
  $$('[data-loc-toggle]').forEach((btn) => {
    const pop = document.getElementById(btn.getAttribute('aria-controls'));
    if (!pop) return;
    const set = (open) => { pop.hidden = !open; btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', (e) => { e.stopPropagation(); set(pop.hidden); });
    document.addEventListener('click', (e) => { if (!pop.hidden && !pop.contains(e.target)) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) { set(false); btn.focus(); } });
  });
  $$('[data-loc-sel]').forEach((sel) => sel.addEventListener('change', () => {
    // Limba aleasă de client nu mai e schimbată automat după țară (vd-lang-auto).
    if (sel.name === 'language_code') { try { localStorage.setItem('vd_lang', sel.value); } catch (e) { /* fără stocare */ } }
    sel.form.submit();
  }));

  /* ---------- Pagina coșului ---------- */
  if (V.template === 'cart') setTimeout(openCart, 250);
})();
